import { render, staticRenderFns } from "./save_template_overlay.vue?vue&type=template&id=87867c8a&scoped=true&"
import script from "./save_template_overlay.vue?vue&type=script&lang=js&"
export * from "./save_template_overlay.vue?vue&type=script&lang=js&"
import style0 from "./save_template_overlay.vue?vue&type=style&index=0&id=87867c8a&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "87867c8a",
  null
  
)

export default component.exports